import * as React from 'react'

export const LoaderIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="64"
      height="64"
      viewBox="0 0 64 64"
      fill="none"
      className={className}
    >
      <path
        d="M26.875 2.79317C27.25 4.29317 26.375 6.04317 24.75 6.41817C13.875 9.54317 6 19.6682 6 31.4182C6 45.7932 17.625 57.4182 32 57.4182C46.25 57.4182 58 45.7932 58 31.4182C58 19.6682 50 9.54317 39.125 6.41817C37.5 6.04317 36.625 4.41817 37 2.79317C37.5 1.16817 39.125 0.293175 40.75 0.668175C54.125 4.54317 64 16.9182 64 31.4182C64 49.1682 49.625 63.4182 32 63.4182C14.25 63.4182 0 49.1682 0 31.4182C0 16.9182 9.75 4.54317 23.125 0.668175C24.75 0.293175 26.375 1.16817 26.875 2.79317Z"
        fill="url(#paint0_linear_574_38357)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_574_38357"
          x1="0"
          y1="32.0001"
          x2="63.9989"
          y2="32.0001"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#2C57FF" />
          <stop offset="1" stopColor="#48A1FF" />
        </linearGradient>
      </defs>
    </svg>
  )
}
